require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2004-08-24-the-999-out-of-1000-rule.json") })
        }
      }, "path---articles-2004-08-24-the-999-out-of-1000-rule");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2004-08-24-the-999-out-of-1000-rule!./.cache/json/articles-2004-08-24-the-999-out-of-1000-rule.json
// module id = 359
// module chunks = 231608221292675